<!DOCTYPE html>
<!-- added title -->
<ion-row class="title-head">
  <ion-col size="10">
    <p class="status-title"> {{ "syndicate-status.pageTitle" | translate }}</p>
  </ion-col>
  <ion-col size="2">
    <ion-icon name="close-circle" (click)="dismiss()" class="close-icon"></ion-icon>
  </ion-col>
</ion-row>
@if (showPausedSyndicate && !loader) {
  <ion-content class="over-scroll">
    <div class="page-background-blue">
      @if (syndicate?.syndicate_type?.toLowerCase().trim() === 'ongoing') {
        <ion-grid class="ion-no-padding">
          <div class="ion-no-margin page-padding">
            @if (syndicate?.active_status?.toLowerCase().trim() === 'paused') {
              <ion-row class="sub-titles">
                <h1 class="syndicate-current-status">{{ "syndicate-status.Paused syndicate" | translate }}</h1>
                <p class="syndicate-status-description">
                  {{ "syndicate-status.nocharges" | translate }}
                </p>
              </ion-row>
            }
            @if (syndicate?.active_status?.toLowerCase().trim() !== 'paused') {
              <ion-row class="sub-titles">
                <h1 class="syndicate-current-status">{{ "syndicate-status.Ongoing syndicate" | translate }}</h1>
                <p class="syndicate-status-description">
                  {{ "syndicate-status.Play" | translate }}
                </p>
              </ion-row>
            }
          </div>
          <!-- toggle btn with unpaused date syndicate -->
          @if (syndicate?.next_draw_status !== 'unpaid' && syndicate.active_status === 'paused') {
            <div class="page-background-white radio-btn-wrapper"
              >
              <ion-row class="page-padding no-padding-row options">
                <ion-col size="10" class="ion-no-padding">
                  <h4 class="deal-option">{{ "syndicate-status.Pause syndicate" | translate }}</h4>
                </ion-col>
                <ion-col class="ion-no-padding">
                  <ion-toggle mode="ios" name="pauseSyndicate" [(ngModel)]="isPausedChecked"
                    (ionChange)="onPauseToggleChange($event, syndicate.active_status === 'paused' ? true : false)">
                  </ion-toggle>
                  <div class="masking-wrapper"></div>
                </ion-col>
              </ion-row>
              @if (syndicate?.active_status?.toLowerCase().trim() === 'paused') {
                <ion-row class="options">
                  <ion-col size="6" class="ion-no-padding">
                    <h4 class="deal-option">{{ "syndicate-status.Resume date" | translate }}</h4>
                  </ion-col>
                  <ion-col size="6" class="ion-no-padding">
                    <h1 class="resume-date">
                      {{
                      syndicate?.next_resume_date
                      ? (syndicate?.next_resume_date?.toDate() | date: "d MMM yyyy")
                      : ("subscription-settings.resumeDateUnavailable" | translate)
                      }}
                    </h1>
                  </ion-col>
                </ion-row>
              }
            </div>
          }
          @if (syndicate.active_status !== 'paused') {
            <ion-row>
              <img src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fsyndicate-status_200x200.webp?alt=media" alt="" class="status-img" />
            </ion-row>
          }
          @if (syndicate.active_status !== 'paused') {
            <ion-row class="desc-tag">
              <p class="take-a-break">{{ "syndicate-status.takeBreak" | translate }}</p>
            </ion-row>
          }
          @if (syndicate.active_status !== 'paused') {
            <ion-row class="des-tag">
              <p class="suspended-date">{{ "syndicate-status.suspend text" | translate }}{{ getResumeDate() }}</p>
            </ion-row>
          }
          <ion-row class="pause-row">
            @if (syndicate.active_status !== 'paused') {
              <button class="pause-btn"
                (click)="onPauseToggleChange(true, syndicate.active_status === 'paused' ? true : false)">
                {{ "syndicate-status.Pause" | translate }}
              </button>
            }
          </ion-row>
        </ion-grid>
      }
      @if (
        syndicate?.syndicate_type?.toLowerCase().trim() === 'one-off' ||
        syndicate?.syndicate_type?.toLowerCase().trim() === '2 weeks' ||
        syndicate?.syndicate_type?.toLowerCase().trim() === '4 weeks' ||
        syndicate?.syndicate_type?.toLowerCase().trim() === '8 weeks'
        ) {
        <ion-grid class="ion-no-padding">
          <div class="ion-no-margin page-padding">
            <ion-row>
              <h1 class="syndicate-current-status">{{ "syndicate-status.One-off syndicate" | translate }}</h1>
              <p class="syndicate-status-description">{{ "syndicate-status.Play only once" | translate }}</p>
            </ion-row>
          </div>
        </ion-grid>
      }
      @if (
        syndicate?.syndicate_type?.toLowerCase().trim() === 'ongoing' &&
        syndicate.active_status?.toLowerCase().trim() !== 'paused'
        ) {
        <h1 class="txt-leave-syndicate warning-text" (click)="leaveSyndicateConfirmation()">
          {{ "syndicate-status.Leave syndicate" | translate }}
        </h1>
      }
    </div>
  </ion-content>
}
@if (!loader && !showPausedSyndicate && syndicatePageOffer$ |async; as card) {
  <ion-content>
    <!-- start no-active-state -->
    <div class="no-active-state">
      <h3 class="title"> {{ "Syndicatepage.noActive" | translate }}</h3>
      <img src="../../../assets/icon/em-logo.png" alt="euro-logo" class="millions-logo" />
      <div class="bottom-wrapper">
        <h4 class="detail-title"> {{lottryDescription$ | async}}</h4>
        <p class="detail-text">  {{card?.content[selectedLanguage]?.title_lines}}</p>
        <button class="btn-join"
        (click)="goToCheckout(card?.product_reference?.real_name,card?.offer_id)">{{card?.content[selectedLanguage]?.button_label}}</button>
      </div>
    </div>
    <!-- end no-active-state -->
  </ion-content>
}